var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "_flexcol _gap-4 _py-2",
      attrs: { "data-qa": "project-properties-box" },
    },
    [
      _c(
        "div",
        {
          staticClass: "_grid _gap-4",
          class: { "_grid-cols-2--l": _vm.hasCoCreators },
        },
        [
          _c("div", { staticClass: "_ov-h" }, [
            _c("div", { staticClass: "gfu-project-banner__field-label" }, [
              _vm._v(
                _vm._s(_vm.Resources.ProjectHome.ProjectStoryCreatorLabel)
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "gfu-media _mt-2" }, [
              _vm.mappedCreator.avatarUrl
                ? _c(
                    "a",
                    {
                      staticClass: "_mr-3",
                      attrs: {
                        href: _vm.mappedCreator.url,
                        "data-qa": "project-properties:AvatarImage",
                      },
                    },
                    [
                      _c("base-image", {
                        staticClass: "_rounded--common",
                        attrs: {
                          src: _vm.mappedCreator.avatarUrl,
                          alt: _vm.mappedCreator.name,
                          width: "48",
                          height: "48",
                          loading: "lazy",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "gfu-media__body _flexcol _gap-1 _ov-h" },
                [
                  _c("h3", { staticClass: "gfu-hd gfu-hd--h2 _toe" }, [
                    _c(
                      "a",
                      {
                        staticClass: "gfu-link gfu-link--nofx _whs-nw",
                        attrs: {
                          href: _vm.mappedCreator.url,
                          "data-qa": "project-properties:CreatorName",
                        },
                      },
                      [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.mappedCreator.name) +
                            "\n                        "
                        ),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "_whs-nw" }, [
                    _c(
                      "a",
                      {
                        staticClass: "gfu-link gfu-link--accent _mr-2",
                        attrs: {
                          href: _vm.mappedCreator.url,
                          rel: "nofollow",
                          "data-qa": "project-properties:MoreInfo",
                        },
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.Resources.ProjectHome.ProjectStoryMoreInfoLink
                          )
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "gfu-link gfu-link--accent",
                        attrs: {
                          href: _vm.projectContactUrl,
                          "data-qa": "project-properties:Contact",
                        },
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.Resources.ProjectHome.ProjectStoryContactLink
                          )
                        ),
                      ]
                    ),
                  ]),
                ]
              ),
            ]),
          ]),
          _vm._v(" "),
          _vm.hasCoCreators
            ? _c("div", { staticClass: "_ov-h" }, [
                _c("div", { staticClass: "gfu-project-banner__field-label" }, [
                  _vm._v(_vm._s(_vm.coCreatorSectionLabel)),
                ]),
                _vm._v(" "),
                _vm.hasOneCoCreator
                  ? _c("div", { staticClass: "gfu-media _mt-2" }, [
                      _vm.firstCoCreator.avatarUrl
                        ? _c(
                            "a",
                            {
                              staticClass: "_mr-3",
                              attrs: { href: _vm.firstCoCreator.url },
                            },
                            [
                              _c("base-image", {
                                staticClass: "_rounded--common",
                                attrs: {
                                  src: _vm.firstCoCreator.avatarUrl,
                                  alt: _vm.firstCoCreator.name,
                                  width: "48",
                                  height: "48",
                                  loading: "lazy",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "gfu-media__body _flexcol _gap-1 _ov-h",
                        },
                        [
                          _c("h3", { staticClass: "gfu-hd gfu-hd--h2 _toe" }, [
                            _c(
                              "a",
                              {
                                staticClass: "gfu-link gfu-link--nofx _whs-nw",
                                attrs: {
                                  href: _vm.firstCoCreator.url,
                                  "data-qa": "project-properties:CoCreatorName",
                                },
                              },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(_vm.firstCoCreator.name) +
                                    "\n                        "
                                ),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", [
                            _c(
                              "a",
                              {
                                staticClass:
                                  "gfu-link gfu-link--accent _whs-nw",
                                attrs: {
                                  href: _vm.firstCoCreator.url,
                                  rel: "nofollow",
                                },
                              },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(
                                      _vm.Resources.ProjectHome
                                        .ProjectStoryMoreInfoLink
                                    ) +
                                    "\n                        "
                                ),
                              ]
                            ),
                          ]),
                        ]
                      ),
                    ])
                  : _c(
                      "div",
                      { staticClass: "_flex _gap-2 _flexwrap _mt-2 _ai-c" },
                      _vm._l(_vm.mappedCoCreators, function (coCreator) {
                        return _c(
                          "tooltip",
                          {
                            key: coCreator.url,
                            attrs: {
                              tag: "span",
                              mode: _vm.isMobile ? "click" : "hover",
                              "is-link-behavior-preserved": !_vm.isMobile,
                              "data-qa": `project-co-creator-name:${coCreator.name}`,
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "content",
                                  fn: function () {
                                    return [
                                      _c("span", [
                                        _vm._v(_vm._s(coCreator.name)),
                                      ]),
                                      _vm._v(" "),
                                      _vm.isMobile
                                        ? _c(
                                            "a",
                                            {
                                              staticClass:
                                                "gfu-link _tdu _ml-1",
                                              attrs: { href: coCreator.url },
                                              on: {
                                                touchstart: function ($event) {
                                                  $event.stopPropagation()
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                            " +
                                                  _vm._s(
                                                    _vm.Resources.ProjectHome
                                                      .ProjectStoryMoreInfoLink
                                                  ) +
                                                  "\n                        "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ],
                              null,
                              true
                            ),
                          },
                          [
                            _c(
                              "a",
                              { attrs: { href: coCreator.url } },
                              [
                                _c("base-image", {
                                  staticClass: "_rounded--common",
                                  attrs: {
                                    src:
                                      coCreator.avatarUrl ||
                                      _vm.placeholderImageUrl,
                                    alt: coCreator.name,
                                    width: "48",
                                    height: "48",
                                    loading: "lazy",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        )
                      }),
                      1
                    ),
              ])
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "_grid _grid-cols-2 _grid-cols-3--m _row-gap-4" },
        [
          _vm.gameSpecificProjectPropertiesEnabled
            ? [
                _vm.playersLabelContent
                  ? _c(
                      "div",
                      { attrs: { "data-qa": "project-properties:Players" } },
                      [
                        _c(
                          "div",
                          { staticClass: "gfu-project-banner__field-label" },
                          [
                            _vm._v(
                              "\n                    " +
                                _vm._s(
                                  _vm.Resources.ProjectHome
                                    .ProjectPropertiesPlayersLabel
                                ) +
                                "\n                "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "gfu-project-banner__field-value _mt-1",
                          },
                          [
                            _vm._v(
                              "\n                    " +
                                _vm._s(_vm.playersLabelContent) +
                                "\n                "
                            ),
                          ]
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.playTimeLabelContent
                  ? _c(
                      "div",
                      { attrs: { "data-qa": "project-properties:PlayTime" } },
                      [
                        _c(
                          "div",
                          { staticClass: "gfu-project-banner__field-label" },
                          [
                            _vm._v(
                              "\n                    " +
                                _vm._s(
                                  _vm.Resources.ProjectHome
                                    .ProjectPropertiesPlayTimeLabel
                                ) +
                                "\n                    "
                            ),
                            _vm.projectProperties.playTimeDescription
                              ? _c("tooltip", {
                                  staticClass: "gfu-project-banner__tooltip",
                                  attrs: {
                                    text: _vm.projectProperties
                                      .playTimeDescription,
                                    "icon-name": "circle-info",
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "gfu-project-banner__field-value _mt-1",
                          },
                          [
                            _vm._v(
                              "\n                    " +
                                _vm._s(_vm.playTimeLabelContent) +
                                "\n                "
                            ),
                          ]
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.projectProperties.minAge
                  ? _c(
                      "div",
                      { attrs: { "data-qa": "project-properties:Age" } },
                      [
                        _c(
                          "div",
                          { staticClass: "gfu-project-banner__field-label" },
                          [
                            _vm._v(
                              "\n                    " +
                                _vm._s(
                                  _vm.Resources.ProjectHome
                                    .ProjectPropertiesAgeLabel
                                ) +
                                "\n                "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "gfu-project-banner__field-value _mt-1",
                          },
                          [
                            _vm._v(
                              "\n                    " +
                                _vm._s(_vm.projectProperties.minAge) +
                                " +\n                "
                            ),
                          ]
                        ),
                      ]
                    )
                  : _vm._e(),
              ]
            : _vm._e(),
          _vm._v(" "),
          !!_vm.projectCategory
            ? _c("div", [
                _c("div", { staticClass: "gfu-project-banner__field-label" }, [
                  _vm._v(
                    "\n                " +
                      _vm._s(
                        _vm.Resources.ProjectHome.ProjectPropertiesCategoryLabel
                      ) +
                      "\n            "
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "gfu-project-banner__field-value gfu-project-banner__field-value--tags",
                  },
                  [
                    _c(
                      "base-tag",
                      {
                        key: _vm.projectCategory.name,
                        staticClass: "_mr-1",
                        attrs: {
                          theme: "accent",
                          href: _vm.projectCategory.url,
                          tag: "a",
                        },
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.projectCategory.name) +
                            "\n                "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.projectHasTags
            ? _c(
                "div",
                {
                  staticClass: "_col-span-2",
                  attrs: { "data-qa": "project-properties:Genre" },
                },
                [
                  _c(
                    "div",
                    { staticClass: "gfu-project-banner__field-label" },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm.Resources.ProjectHome.ProjectPropertiesTagsLabel
                          ) +
                          "\n            "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "gfu-project-banner__field-value gfu-project-banner__field-value--tags",
                    },
                    _vm._l(_vm.visibleProjectTags, function (tag) {
                      return _c(
                        "base-tag",
                        {
                          key: tag.name,
                          staticClass: "_mr-1",
                          attrs: { href: tag.url, tag: "a" },
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(tag.name) +
                              "\n                "
                          ),
                        ]
                      )
                    }),
                    1
                  ),
                ]
              )
            : _vm._e(),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }